// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

import '@/common/css/normalize.css'
import '@/common/css/style.css'

import axios from 'axios'
// http://60.210.100.74:7071/
// 192.168.101.23:8383
axios.defaults.baseURL = 'http://60.210.100.74:7071/';
Vue.prototype.$axios = axios //全局注册，使用方法为:this.$axios

import global from './components/Global'
Vue.prototype.GLOBAL = global

import * as filters from './filters' // global filters
// register global utility filters
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
Vue.use(ElementUI);
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js